/**
 * Blinkit-style floating cart — dual milestone bar, stacked thumbs, unlock animation.
 */
window.IfFloatingCart = (function () {
  var cfg = window.IF_FREE_GIFT || {};
  var M1 = cfg.m1 || 49900;
  var M2 = cfg.m2 || 99900;
  var M1_PCT = M2 > 0 ? (M1 / M2) * 100 : 50;

  var lastPayable = null;
  var celebrateTimer = null;

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function formatMoney(cents) {
    var amount = Math.round(cents / 100);
    try {
      return new Intl.NumberFormat('en-IN', {
        style: 'currency',
        currency: 'INR',
        maximumFractionDigits: 0,
      }).format(amount);
    } catch (e) {
      return '₹' + amount.toLocaleString('en-IN');
    }
  }

  function formatMoneyHtml(cents) {
    var plain = formatMoney(cents);
    var match = plain.match(/^(\s*(?:₹|Rs\.?)\s*)(.+)$/i);
    if (match) {
      return (
        '<span class="if-float-cart__money-curr">' +
        match[1].trim() +
        '</span><span class="if-float-cart__money-amt">' +
        match[2].trim() +
        '</span>'
      );
    }
    return '<span class="if-float-cart__money-amt">' + plain + '</span>';
  }

  function payableTotal(cart) {
    if (window.IfFreeGift && typeof window.IfFreeGift.payableTotal === 'function') {
      return window.IfFreeGift.payableTotal(cart);
    }
    return cart.total_price || 0;
  }

  function isGiftLine(item) {
    if (!item) return false;
    if (window.IfFreeGift && typeof window.IfFreeGift.isGiftItem === 'function') {
      return window.IfFreeGift.isGiftItem(item);
    }
    return item.properties && item.properties._if_gift === 'true';
  }

  function stackImages(cart) {
    var out = [];
    var items = cart.items || [];
    for (var i = 0; i < items.length && out.length < 3; i++) {
      if (isGiftLine(items[i])) continue;
      if (items[i].image) {
        out.push({
          url: items[i].image,
          alt: items[i].product_title || items[i].title || '',
        });
      }
    }
    return out;
  }

  function milestoneState(payable) {
    var overallPct = M2 > 0 ? Math.min(100, Math.round((payable / M2) * 100)) : 0;
    var seg1 = 0;
    var seg2 = 0;
    var tier = 'empty';
    var unlock = 'Shop ' + formatMoneyHtml(M1) + '+ for free delivery';
    var reward = 'FREE DELIVERY';

    if (payable < M1) {
      tier = 'm1';
      seg1 = M1 > 0 ? Math.min(100, Math.round((payable / M1) * 100)) : 0;
      seg2 = 0;
      unlock = 'Add ' + formatMoneyHtml(M1 - payable) + ' more to unlock';
      reward = 'FREE DELIVERY';
    } else if (payable < M2) {
      tier = 'm2';
      seg1 = 100;
      var span = M2 - M1;
      seg2 = span > 0 ? Math.min(100, Math.round(((payable - M1) / span) * 100)) : 0;
      unlock = 'Add ' + formatMoneyHtml(M2 - payable) + ' more to unlock';
      reward = 'FREE GIFT';
    } else if (payable > 0) {
      tier = 'done';
      seg1 = 100;
      seg2 = 100;
      unlock = 'All rewards unlocked';
      reward = 'CHECKOUT NOW';
    }

    return {
      overallPct: overallPct,
      seg1: seg1,
      seg2: seg2,
      tier: tier,
      unlock: unlock,
      reward: reward,
    };
  }

  function runCelebrate(bar, kind) {
    var title = bar.querySelector('[data-celebrate-title]');
    var sub = bar.querySelector('[data-celebrate-sub]');
    var extra = bar.querySelector('[data-celebrate-extra]');
    var emoji = bar.querySelector('[data-celebrate-emoji]');

    bar.classList.remove('if-float-cart--celebrate-delivery', 'if-float-cart--celebrate-gift', 'if-float-cart--celebrate-all');

    if (kind === 'delivery') {
      bar.classList.add('if-float-cart--celebrate-delivery');
      if (title) title.textContent = 'You unlocked';
      if (sub) sub.textContent = 'FREE DELIVERY';
      if (extra) {
        extra.textContent = '';
        extra.hidden = true;
      }
      if (emoji) emoji.textContent = '🛵';
    } else if (kind === 'gift') {
      bar.classList.add('if-float-cart--celebrate-gift');
      if (title) title.textContent = 'You unlocked';
      if (sub) sub.textContent = 'FREE GIFT';
      if (extra) {
        extra.textContent = 'Claim it from your cart';
        extra.hidden = false;
      }
      if (emoji) emoji.textContent = '🎁';
    } else {
      bar.classList.add('if-float-cart--celebrate-all');
      if (title) title.textContent = 'You unlocked';
      if (sub) sub.textContent = 'ALL REWARDS';
      if (extra) {
        extra.textContent = 'Free delivery + gifts — checkout!';
        extra.hidden = false;
      }
      if (emoji) emoji.textContent = '🎉';
    }

    bar.classList.add('if-float-cart--celebrating');
    if (celebrateTimer) clearTimeout(celebrateTimer);
    celebrateTimer = setTimeout(function () {
      bar.classList.remove(
        'if-float-cart--celebrating',
        'if-float-cart--celebrate-delivery',
        'if-float-cart--celebrate-gift',
        'if-float-cart--celebrate-all'
      );
    }, 5200);
  }

  function maybeCelebrate(bar, payable) {
    if (lastPayable === null) {
      lastPayable = payable;
      return;
    }
    if (lastPayable < M1 && payable >= M1 && payable < M2) {
      runCelebrate(bar, 'delivery');
    } else if (lastPayable < M2 && payable >= M2) {
      runCelebrate(bar, 'gift');
    }
    lastPayable = payable;
  }

  function promoStrip() {
    return document.querySelector('[data-if-cart-promo-strip]');
  }

  function setCartChrome(bar, mode) {
    var isPromo = mode === 'promo';
    var isPill = mode === 'pill';
    var strip = promoStrip();

    bar.classList.toggle('if-float-cart--hidden', !isPill);
    bar.setAttribute('aria-hidden', isPill ? 'false' : 'true');

    if (isPromo) {
      bar.classList.remove(
        'if-float-cart--celebrating',
        'if-float-cart--celebrate-delivery',
        'if-float-cart--celebrate-gift',
        'if-float-cart--celebrate-all'
      );
    }

    if (strip) strip.hidden = !isPromo;

    document.body.classList.toggle('has-if-float-promo', isPromo);
    document.body.classList.toggle('has-if-float-cart', isPill);
  }

  function setTier(bar, tier) {
    bar.classList.remove('if-float-cart--m1', 'if-float-cart--m2', 'if-float-cart--done', 'if-float-cart--empty');
    bar.classList.add('if-float-cart--' + tier);
  }

  function updateStack(bar, images) {
    var stack = bar.querySelector('[data-if-float-stack]');
    if (!stack) return;
    stack.innerHTML = '';
    if (!images.length) return;
    images.forEach(function (img, i) {
      var el = document.createElement('img');
      el.className = 'if-float-cart__stack-img';
      el.src = img.url;
      el.alt = img.alt || '';
      el.width = 32;
      el.height = 32;
      el.loading = 'lazy';
      el.style.setProperty('--stack-i', String(i));
      stack.appendChild(el);
    });
  }

  function updateFromCart(cart) {
    var bar = document.querySelector('[data-if-float-cart]');
    if (!bar) return;

    var count = cart.item_count || 0;
    if (!count) {
      setCartChrome(bar, 'promo');
      lastPayable = null;
      return;
    }

    setCartChrome(bar, 'pill');

    var payable = payableTotal(cart);
    maybeCelebrate(bar, payable);

    var state = milestoneState(payable);
    setTier(bar, state.tier);
    bar.style.setProperty('--if-float-m1-pct', M1_PCT + '%');

    var unlockEl = bar.querySelector('[data-if-float-unlock]');
    var rewardEl = bar.querySelector('[data-if-float-reward]');
    var countLineEl = bar.querySelector('[data-if-float-count-line]');
    var seg1El = bar.querySelector('[data-if-float-seg1]');
    var seg2El = bar.querySelector('[data-if-float-seg2]');
    var knobEl = bar.querySelector('[data-if-float-knob]');
    var track = bar.querySelector('.if-float-cart__track');

    if (unlockEl) unlockEl.innerHTML = state.unlock;
    if (rewardEl) rewardEl.textContent = state.reward;
    if (countLineEl) {
      countLineEl.textContent = count + (count === 1 ? ' item' : ' items');
    }
    if (seg1El) seg1El.style.width = state.seg1 + '%';
    if (seg2El) seg2El.style.width = state.seg2 + '%';
    if (knobEl) knobEl.style.left = state.overallPct + '%';
    if (track) track.setAttribute('aria-valuenow', String(state.overallPct));

    updateStack(bar, stackImages(cart));
    syncProductCartOffset();
  }

  function refresh() {
    return fetch(root() + 'cart.js')
      .then(function (r) {
        return r.json();
      })
      .then(updateFromCart)
      .catch(function () {});
  }

  function openDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') {
      drawer.open();
      return;
    }
    window.location.href = root() + 'cart';
  }

  function isProductPage() {
    return (
      document.body.classList.contains('template-product') ||
      !!document.querySelector('.custom_product_page') ||
      !!document.querySelector('.if-float-cart--product')
    );
  }

  function syncProductCartOffset() {
    if (!isProductPage()) return;
    var buyBar = document.querySelector('.custom_buy_section .custom_buy_buttons');
    if (!buyBar) return;
    var h = Math.ceil(buyBar.getBoundingClientRect().height);
    if (h > 0) {
      document.documentElement.style.setProperty('--if-product-buybar-h', h + 'px');
    }
  }

  function hideProductHelp() {
    if (!isProductPage()) return;
    var nodes = document.querySelectorAll(
      'shopify-chat, #shopify-chat, #ShopifyChat, inbox-online-store-chat, #shopify-chat iframe, iframe#dummy-chat-button-iframe, iframe[name="dummy-chat-button-iframe"]'
    );
    nodes.forEach(function (el) {
      var open =
        el.getAttribute('is-open') === 'true' ||
        el.getAttribute('isOpen') === 'true' ||
        el.getAttribute('aria-hidden') === 'false';
      if (open) return;
      el.style.setProperty('display', 'none', 'important');
      el.style.setProperty('visibility', 'hidden', 'important');
      el.style.setProperty('opacity', '0', 'important');
      el.style.setProperty('pointer-events', 'none', 'important');
    });
  }

  function bind() {
    hideProductHelp();
    syncProductCartOffset();
    window.addEventListener('resize', syncProductCartOffset);
    if (typeof MutationObserver !== 'undefined') {
      new MutationObserver(hideProductHelp).observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['is-open', 'isOpen', 'aria-hidden', 'style'],
      });
    }

    var bar = document.querySelector('[data-if-float-cart]');
    var stripEl = promoStrip();
    if (!bar && !stripEl) {
      document.body.classList.remove('has-if-float-cart', 'has-if-float-promo');
      return;
    }
    if (!bar) return;

    var pill = bar.querySelector('[data-if-float-cart-open]');
    if (pill) {
      pill.addEventListener('click', function () {
        openDrawer();
      });
    }

    var strip = promoStrip();
    if (strip && !strip.hidden) {
      document.body.classList.add('has-if-float-promo');
      document.body.classList.remove('has-if-float-cart');
    } else if (bar && !bar.classList.contains('if-float-cart--hidden')) {
      document.body.classList.add('has-if-float-cart');
      document.body.classList.remove('has-if-float-promo');
    }

    document.addEventListener('cart:updated', function (e) {
      var detail = e.detail;
      var cart = (detail && detail.cart) || (detail && detail.items ? detail : null);
      if (cart && cart.items) updateFromCart(cart);
      else refresh();
    });

    document.addEventListener('cart:refresh', refresh);
    document.addEventListener('cart:item-added', function (e) {
      var detail = e.detail;
      var cart = (detail && detail.cart) || (detail && detail.items ? detail : null);
      if (cart && cart.items) updateFromCart(cart);
      else refresh();
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        if (event && event.cartData && event.cartData.items) updateFromCart(event.cartData);
        else refresh();
      });
    }

    refresh();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }

  return { update: updateFromCart, refresh: refresh };
})();
